var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"hamburger-button"},on:{"click":function($event){return _vm.responsiveOpenNav()}}},[_c('iconHamburgerButton',{staticClass:"d-block"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }